// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';

import ApplyOptions from '../apply-options';
import JobDescriptionDialog from '../job-description-dialog';
import JobCompensation from '../job-compensation';
import { getCustomerLogoPath } from '../../util/customer';
import { InactiveJob } from '../inactive-job';
import { CareersPageButton } from '../careers-page-button';

const styles = theme => ({
  logo: {
    display: 'block',
    maxWidth: '150px',
    align: 'left',
  },
  logoMobile: {
    display: 'block',
    maxWidth: '150px',
    margin: 'auto',
    marginTop: '40px',
    marginBottom: '15px',
  },
  container: {
    backgroundColor: 'white',
  },
  section: {
    paddingBottom: '20px',
  },
  headline: {
    lineHeight: '1.1em',
    marginBottom: 0,
    align: 'left',
  },
  mobileHeadline: {
    margin: '0px 25px 0px 25px',
    lineHeight: '1.1em',
    marginBottom: 0,
    align: 'left',
  },
  mobileCaption: {
    margin: '5px 25px 0px 25px',
  },
  mobileApplyText: {
    margin: '30px 25px 20px 25px',
  },
  applyText: {
    fontWeight: 300,
  },
});

type Props = {
  classes: Object,
  job: Job,
  jobCompensation: Object | null,
  org: Org,
}

type State = {
}

const style = {
  padding: '10px 0',
};


class JobDescriptionB extends React.PureComponent<Props, State> {
  render() {
    const { classes, job, jobCompensation, org } = this.props;
    const { status } = job;
    const isJobHiring = ['PUBLISHED', 'ACTIVE'].includes(status);
    const logoPath = getCustomerLogoPath(org);
    return (
      <div className={classes.container}>
        {/* TODO - open link in new window */}
        <Grid container alignItems="center" justify="center" className={classes.section}>
          <Hidden xsDown>
            <Grid item xs={6}>
              <a href={org.website}><img src={logoPath} className={classes.logo} alt="Home" /></a>
            </Grid>
            <Grid item xs={6}>
              <div style={style}>
                <div>
                  <Typography variant="h5" className={classes.headline} gutterBottom>{job.title}</Typography>
                </div>
                {job.city && job.state &&
                <div>
                  <Typography variant="caption" gutterBottom>{job.city}, {job.state}</Typography>
                </div>
                }
                <JobCompensation
                  offeredCompensation={jobCompensation}
                  typographyClass={classes.caption}
                  variant="typography"
                  typographyVariant="caption"
                />
              </div>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid item xs={12}>
              <a href={org.website}><img src={logoPath} className={classes.logoMobile} alt="Home" /></a>
            </Grid>
          </Hidden>
        </Grid>
        {isJobHiring ? (
          <>
            <Grid container alignItems="center" justify="center" className={classes.section}>
            {/* The job description contains html to format it. Make sure this is safe
            and we never get raw html directly from a user */}
            <Grid item xs={12}>
              <Hidden smUp>
                <div>
                  <div>
                    <Typography variant="h5" className={classes.mobileHeadline} gutterBottom>{job.title}</Typography>
                  </div>
                  {job.city && job.state &&
                  <div>
                    <Typography variant="caption" className={classes.mobileCaption} gutterBottom>{job.city}, {job.state}</Typography>
                  </div>
                  }
                </div>
                <Typography variant="subtitle1" className={classes.mobileApplyText}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{ __html: job.shortDescription }} />
                </Typography>
                {job.jobSpecificDescriptionText &&
                <Typography variant="subtitle1" className={classes.mobileApplyText}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{
                    __html: job.jobSpecificDescriptionText,
                  }}
                  />
                </Typography>
                }
              </Hidden>
              <Hidden xsDown>
                <Typography variant="subtitle1" className={classes.applyText}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{ __html: job.shortDescription }} />
                </Typography>
                {job.jobSpecificDescriptionText &&
                <Typography variant="subtitle1" className={classes.applyText}>
                  {/* eslint-disable-next-line */}
                  <div dangerouslySetInnerHTML={{
                    __html: job.jobSpecificDescriptionText,
                  }}
                  />
                </Typography>
                }
              </Hidden>
            </Grid>
          </Grid>
          <ApplyOptions />
          <Grid container alignItems="center" justify="center" className={classes.section}>
            <JobDescriptionDialog
              job={job}
              org={org}
              jobCompensation={jobCompensation}
            />
          </Grid>
          </>
        ) : (
          <>
            <InactiveJob job={job} org={org} />
            <CareersPageButton org={org} />
          </>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(JobDescriptionB);
